import { render, staticRenderFns } from "./systemBasicConfig.vue?vue&type=template&id=1b445f1e&scoped=true&"
import script from "./systemBasicConfig.vue?vue&type=script&lang=js&"
export * from "./systemBasicConfig.vue?vue&type=script&lang=js&"
import style0 from "./systemBasicConfig.vue?vue&type=style&index=0&id=1b445f1e&prod&scoped=true&lang=css&"
import style1 from "./systemBasicConfig.vue?vue&type=style&index=1&id=1b445f1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b445f1e",
  null
  
)

export default component.exports